export default __webpack_public_path__ + "static/media/no-image.fe727eed.webp";